//  List of all icons, derived from here:
//  https://www.notion.so/fossa/31f5a75ea76c49cdbbe24f4b33d11ed6?v=3d726d3b4a04446ea8ab738133476623

/*
 * IMPORTANT: All icon names **must be unique** across all icon sets. If you need to deconflict a name, add the FontAwesome
 * style as a suffix. For example: book -> bookRegular.
 */

const fossaIcons = {
  addToProject: 'fossa-icon-add-to-project',
  cyclone: 'fossa-icon-cyclone',
  relationship: 'fossa-icon-relationship',
  spdx: 'fossa-icon-spdx',
} as const;

export const solidIcons = {
  alarmExclamation: 'fa-solid fa-alarm-exclamation',
  alarmSnooze: 'fa-solid fa-alarm-snooze',
  alignLeft: 'fa-solid fa-align-left',
  angleDoubleRight: 'fa-solid fa-angle-double-right',
  angleDown: 'fa-solid fa-angle-down',
  angleLeft: 'fa-solid fa-angle-left',
  angleRight: 'fa-solid fa-angle-right',
  angleUp: 'fa-solid fa-angle-up',
  anglesUpDown: 'fa-solid fa-angles-up-down',
  archive: 'fa-solid fa-archive',
  arrowDown: 'fa-solid fa-arrow-down',
  arrowLeft: 'fa-solid fa-arrow-left',
  arrowLeftRight: 'fa-solid fa-arrow-right-arrow-left',
  arrowRight: 'fa-solid fa-arrow-right',
  arrowUp: 'fa-solid fa-arrow-up',
  arrowUpRightDots: 'fa-solid fa-arrow-up-right-dots',
  ban: 'fa-solid fa-ban',
  barChart: 'fa-solid fa-bar-chart',
  book: 'fa-solid fa-book',
  bug: 'fa-solid fa-bug',
  building: 'fa-solid fa-building',
  caretDown: 'fa-solid fa-caret-down',
  caretLeft: 'fa-solid fa-caret-left',
  caretRight: 'fa-solid fa-caret-right',
  caretUp: 'fa-solid fa-caret-up',
  check: 'fa-solid fa-check',
  checkCircle: 'fa-solid fa-check-circle',
  checkSquare: 'fa-solid fa-check-square',
  chevronRight: 'fa-solid fa-chevron-right',
  chevronDown: 'fa-solid fa-chevron-down',
  circle: 'fa-solid fa-circle',
  circleO: 'fa-solid fa-circle-notch',
  circleQuestionSolid: 'fa-solid fa-circle-question',
  circleUpSolid: 'fa-solid fa-circle-up',
  clipboard: 'fa-solid fa-clipboard',
  clone: 'fa-solid fa-clone',
  codeFork: 'fa-solid fa-code-fork',
  cog: 'fa-solid fa-cog',
  creditCard: 'fa-solid fa-credit-card',
  customize: 'fa-solid fa-cogs',
  download: 'fa-solid fa-download',
  ellipsisHorizontal: 'fa-solid fa-ellipsis-h',
  ellipsisVertical: 'fa-solid fa-ellipsis-v',
  envelope: 'fa-solid fa-envelope',
  exclamationCircle: 'fa-solid fa-exclamation-circle',
  expand: 'fa-solid fa-expand',
  externalLink: 'fa-solid fa-external-link',
  eye: 'fa-solid fa-eye',
  eyeSlash: 'fa-solid fa-eye-slash',
  file: 'fa-solid fa-file',
  fileExport: 'fa-solid fa-file-export',
  filter: 'fa-solid fa-filter',
  flag: 'fa-solid fa-flag',
  folder: 'fa-solid fa-folder',
  folderOpen: 'fa-solid fa-folder-open',
  folderPlus: 'fa-solid fa-folder-plus',
  gear: 'fa-solid fa-gear',
  globe: 'fa-solid fa-earth-americas',
  home: 'fa-solid fa-home',
  hourglass: 'fa-solid fa-hourglass',
  infoCircle: 'fa-solid fa-info-circle',
  key: 'fa-solid fa-key',
  link: 'fa-solid fa-link',
  list: 'fa-solid fa-list',
  listTree: 'fa-solid fa-list-tree',
  lock: 'fa-solid fa-lock',
  mask: 'fa-solid fa-masks-theater',
  minus: 'fa-solid fa-minus',
  note: 'fa-solid fa-note',
  paste: 'fa-solid fa-paste',
  pencil: 'fa-solid fa-pencil',
  personDigging: 'fa-solid fa-person-digging',
  phone: 'fa-solid fa-phone',
  pieChart: 'fa-solid fa-pie-chart',
  plane: 'fa-solid fa-paper-plane',
  plus: 'fa-solid fa-plus',
  plusCircle: 'fa-solid fa-plus-circle',
  powerOff: 'fa-solid fa-power-off',
  question: 'fa-solid fa-question',
  questionCircle: 'fa-solid fa-question-circle',
  receiptSolid: 'fa-solid fa-receipt',
  refresh: 'fa-solid fa-refresh',
  reload: 'fa-solid fa-repeat',
  save: 'fa-solid fa-save',
  search: 'fa-solid fa-search',
  server: 'fa-solid fa-server',
  share: 'fa-solid fa-share',
  shieldExclamation: 'fa-solid fa-shield-exclamation',
  shieldHalved: 'fa-solid fa-shield-halved',
  sliders: 'fa-solid fa-sliders',
  sort: 'fa-solid fa-sort',
  sortAscending: 'fa-solid fa-arrow-up-wide-short',
  sortDescending: 'fa-solid fa-arrow-down-wide-short',
  spinner: 'fa-solid fa-spinner',
  square: 'fa-solid fa-square',
  star: 'fa-solid fa-star',
  stepBackward: 'fa-solid fa-step-backward',
  stepForward: 'fa-solid fa-step-forward',
  times: 'fa-solid fa-times',
  thumbtackSolid: 'fa-solid fa-thumbtack',
  trash: 'fa-solid fa-trash',
  undo: 'fa-solid fa-undo',
  upload: 'fa-solid fa-upload',
  user: 'fa-solid fa-user',
  userCircle: 'fa-solid fa-user-circle',
  userXMark: 'fa-solid fa-user-xmark',
  users: 'fa-solid fa-users',
  warning: 'fa-solid fa-warning',
  xCircleSolid: 'fa-solid fa-circle-x',
  xMark: 'fa-solid fa-xmark',
  zipFile: 'fa-solid fa-file-zipper',
} as const;

export const regularIcons = {
  add: 'fa-regular fa-circle-plus',
  alarmSnoozeO: 'fa-regular fa-alarm-snooze',
  alarmExclamationO: 'fa-regular fa-alarm-exclamation',
  alien8bit: 'fa-regular fa-alien-8bit',
  api: 'fa-regular fa-rectangle-code',
  arrowsFromLine: 'fa-regular fa-arrows-from-line',
  arrowsToLine: 'fa-regular fa-arrows-to-line',
  badgeCheck: 'fa-regular fa-badge-check',
  banOutline: 'fa-regular fa-ban',
  bookRegular: 'fa-regular fa-book',
  box: 'fa-regular fa-box',
  boxArchive: 'fa-regular fa-box-archive',
  boxesPacking: 'fa-regular fa-boxes-packing',
  boxesStacked: 'fa-regular fa-boxes-stacked',
  boxTaped: 'fa-regular fa-box-taped',
  boxOpen: 'fa-regular fa-box-open',
  bugRegular: 'fa-regular fa-bug',
  calendarO: 'fa-regular fa-calendar',
  checkOutline: 'fa-regular fa-check',
  checkCircleO: 'fa-regular fa-check-circle',
  checklist: 'fa-regular fa-clipboard-list-check',
  circleInfo: 'fa-regular fa-circle-info',
  circleQuestion: 'fa-regular fa-circle-question',
  circleStar: 'fa-regular fa-circle-star',
  circleThin: 'fa-regular fa-circle',
  circleUp: 'fa-regular fa-circle-up',
  circleExclamationCheck: 'fa-regular fa-circle-exclamation-check',
  containerO: 'fa-regular fa-database',
  clockO: 'fa-regular fa-clock',
  clockRotateLeft: 'fa-regular fa-clock-rotate-left',
  cloneO: 'fa-regular fa-clone',
  closeO: 'fa-regular fa-times-circle',
  cloudArrowUp: 'fa-regular fa-cloud-arrow-up',
  code: 'fa-regular fa-code',
  codeCommit: 'fa-regular fa-code-commit',
  codeCompare: 'fa-regular fa-code-compare',
  codeBranch: 'fa-regular fa-code-branch',
  comment: 'fa-regular fa-comment',
  copy: 'fa-regular fa-copy',
  cube: 'fa-regular fa-cube',
  down: 'fa-regular fa-down',
  downloadRegular: 'fa-regular fa-download',
  earth: 'fa-regular fa-earth',
  edit: 'fa-regular fa-pen-to-square',
  exclamationCircleRegular: 'fa-regular fa-exclamation-circle',
  envelopeRegular: 'fa-regular fa-envelope',
  export: 'fa-regular fa-file-export',
  eyeRegular: 'fa-regular fa-eye',
  eyeSlashRegular: `fa-regular fa-eye-slash`,
  fileBinary: 'fa-regular fa-file-binary',
  fileExcelO: 'fa-regular fa-file-excel',
  fileMag: 'fa-regular fa-file-magnifying-glass',
  fileO: 'fa-regular fa-file',
  filePlusO: 'fa-regular fa-file-plus',
  fileOutline: 'fa-regular fa-file-lines',
  filePdfO: 'fa-regular fa-file-pdf',
  filesO: 'fa-regular fa-files',
  fileTextO: 'fa-regular fa-file-text',
  fileWordO: 'fa-regular fa-file-word',
  flagOutline: 'fa-regular fa-flag',
  folderBookmark: 'fa-regular fa-folder-bookmark',
  folderO: 'fa-regular fa-folder',
  folderOpenO: 'fa-regular fa-folder-open',
  folders: 'fa-regular fa-folders',
  globeOutline: 'fa-regular fa-globe',
  hasFix: 'fa-regular fa-face-thinking',
  homeO: 'fa-regular fa-home',
  hourglassO: 'fa-regular fa-hourglass',
  layerGroup: 'fa-regular fa-layer-group',
  linkO: 'fa-regular fa-link',
  listTreeO: 'fa-regular fa-list-tree',
  locationDot: 'fa-regular fa-location-dot',
  lockOutline: 'fa-regular fa-lock',
  lockOpenO: 'fa-regular fa-lock-open',
  majorFix: 'fa-regular fa-forklift',
  minorFix: 'fa-regular fa-wrench-simple',
  minusSquareO: 'fa-regular fa-minus-square',
  minusCircleO: 'fa-regular fa-minus-circle',
  noFix: 'fa-regular fa-ghost',
  noteRegular: 'fa-regular fa-note',
  patchFix: 'fa-regular fa-trowel',
  plusSquareO: 'fa-regular fa-plus-square',
  plusCircleO: 'fa-regular fa-plus-circle',
  questionCircleO: 'fa-regular fa-question-circle',
  receipt: 'fa-regular fa-receipt',
  regularFolder: 'fa-regular fa-folder',
  folderDown: 'fa-regular fa-folder-arrow-down',
  remove: 'fa-regular fa-times-circle',
  review: 'fa-regular fa-file-check',
  reviewFix: 'fa-regular fa-screwdriver-wrench',
  scaleBalanced: 'fa-regular fa-scale-balanced',
  sendBackward: 'fa-regular fa-send-backward',
  shieldHalvedRegular: 'fa-regular fa-shield-halved',
  shieldXMark: 'fa-solid fa-shield-xmark',
  sitemap: 'fa-regular fa-sitemap',
  sparkle: 'fa-regular fa-sparkles',
  squareCheck: 'fa-regular fa-square-check',
  squareO: 'fa-regular fa-square',
  tags: 'fa-regular fa-tags',
  terminal: 'fa-regular fa-terminal',
  ticket: 'fa-regular fa-ticket',
  thumbtack: 'fa-regular fa-thumbtack',
  thumbtackSlash: 'fa-regular fa-thumbtack-slash',
  trashRegular: 'fa-regular fa-trash',
  truckFast: 'fa-regular fa-truck-fast',
  unfilledShare: 'fa-regular fa-share',
  uploadO: 'fa-regular fa-upload',
  userCircleRegular: 'fa-regular fa-user-circle',
  userGroup: 'fa-regular fa-user-group',
  up: 'fa-regular fa-up',
  waveSine: 'fa-regular fa-wave-sine',
  wrench: 'fa-regular fa-wrench',
  xCircle: 'fa-regular fa-circle-x',
  tableTree: 'fa-regular fa-table-tree',
  zipFileO: 'fa-regular fa-file-zipper',
} as const;

export const brandIcons = {
  bitbucket: 'fa-brands fa-bitbucket',
  github: 'fa-brands fa-github',
  gitlab: 'fa-brands fa-gitlab',
  google: 'fa-brands fa-google',
  html5: 'fa-brands fa-html5',
  microsoft: 'fa-brands fa-microsoft',
  openid: 'fa-brands fa-openid',
  linux: 'fa-brands fa-linux',
  slack: 'fa-brands fa-slack',
  swift: 'fa-brands fa-swift',
  windows: 'fa-brands fa-windows',
} as const;

type Icons = typeof fossaIcons & typeof solidIcons & typeof brandIcons & typeof regularIcons;

export const icons: Icons = {
  ...fossaIcons,
  ...solidIcons,
  ...brandIcons,
  ...regularIcons,
} as const;

export type IconType = keyof typeof icons;
export type IconClassName = typeof icons[IconType];

export default icons;
